<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-start row>
    <div style="width: calc(90%)">
      <div style="padding-left: 12px;">
        <SimpleCard>
          <v-flex>
          <v-flex pl-2 shrink style="width: 150px;">
          <v-select @change="getBookingAdditionalCharges" v-model="state" :items="states" item-text="name" item-value="value"/>
          </v-flex>
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <BookingAdditionalChargeSummaryList
              v-if="!loading"
              style="width: 100%;"
              :bookingAdditionalCharges="bookingAdditionalCharges"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getBookingAdditionalCharges"
            ></BookingAdditionalChargeSummaryList>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
          </v-flex>
        </SimpleCard>
      </div>
    </div>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import BookingAdditionalChargeSummaryList from "@/components/booking/BookingAdditionalChargeSummaryList.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "bookings",
  components: {
    SimpleCard,
    BookingAdditionalChargeSummaryList,
  },

  data: function () {
    return {
      bookingAdditionalCharges: [],
      offset: 0,
      count: 20,
      state: "pending",
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: [],
      states: [
        {name: "Pending",value: 'pending'},
        {name: "Completed",value: 'completed'},
        {name: "Cancelled",value: 'cancelled'},
        {name: "Refunded",value: 'refunded'}
      ]
    };
  },
  mounted: async function () {

    this.getBookingAdditionalCharges();
  },
  methods: {
    search: function () {
      this.pagination.page = 1;
      this.getBookingAdditionalCharges();
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getBookingAdditionalCharges();
    },
    getBookingAdditionalCharges: async function () {
      this.loading = true;

      try {
        var url;

        url = `${this.$store.state.apiUrl}/booking_additional_charge/list?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&state=${this.state}`;


        let response = await axios.get(url, {
          params: {},
        });

        var bookingAdditionalCharges = response.data.booking_additional_charges;

        this.bookingAdditionalCharges = bookingAdditionalCharges;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get booking additional charges " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
